Shopify.queue = [];

!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,a=function(t){return parseFloat(t)||0},n=function(e){var o=t(e),n=null,i=[];return o.each(function(){var e=t(this),o=e.offset().top-a(e.css("margin-top")),r=i.length>0?i[i.length-1]:null;null===r?i.push(e):Math.floor(Math.abs(n-o))<=1?i[i.length-1]=r.add(e):i.push(e),n=o}),i},i=function(e){var o={byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var a=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(a)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="master",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,r._afterUpdate=null,r._rows=n,r._parse=a,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0","padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=n(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var n=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&n.length<=1)return void n.css(s.property,"");n.each(function(){var e=t(this),o=e.attr("style"),a=e.css("display");"inline-block"!==a&&"flex"!==a&&"inline-flex"!==a&&(a="block");var n={display:a};n[s.property]="",e.css(n),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}n.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=a(e.css("border-top-width"))+a(e.css("border-bottom-width")),o+=a(e.css("padding-top"))+a(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),a=o.attr("data-mh")||o.attr("data-match-height");e[a]=a in e?e[a].add(o):o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(a,n){if(n&&"resize"===n.type){var i=t(window).width();if(i===e)return;e=i}a?-1===o&&(o=setTimeout(function(){s(n),o=-1},r._throttle)):s(n)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});

$(document).ready(function () {
    $.get("/cart/clear",function(){console.log("Cleared")});
    /* scroll to target */
    jQuery('.scrollTo').click(function (e) {
        e.preventDefault();
        var href = jQuery(this).attr('href');
        var jump = jQuery(this).attr('href');
        var new_position = jQuery(jump).offset();
        jQuery('html, body').stop().animate({ scrollTop: new_position.top }, 800, function () {
            if (href == "#benefits") {
                var new_position_f = jQuery(jump).offset();
                jQuery('html, body').stop().animate({ scrollTop: new_position_f.top + 200 }, 200);
            }

        });
        e.preventDefault();
    });

    /* initialize lazy load*/
    $('.lazy').Lazy();

    /* initialize fancybox */
    $(".fancybox").fancybox();

    window.setTimeout(function(){
        $(".subscribeSaveWrapper,.oneTimePurchaseWrapper").matchHeight();
    },1000);

    $(window).on('resize',function(){
        window.setTimeout(function(){
            $(".subscribeSaveWrapper,.oneTimePurchaseWrapper").matchHeight();
        },50);
    });

    

    jQuery('#testimonial1Slider').owlCarousel({
        items: 2,
        loop: false,
        nav: false,
        navText: ["<span class='material-icons'>keyboard_arrow_left</span>", "<span class='material-icons'>keyboard_arrow_right</span>"],
        dots: false,
        autoplay: false,
        lazyLoad: true,
        responsive: {
            0: {
                items: 1,
                dots: false,
                nav: true,
            },
            600: {
                items: 1,
                dots: false,
                nav: true,
            },
            768: {
                items: 2,
                dots: false,
                nav: false,
            },
            991: {
                items: 2,
                dots: false,
                nav: false,
            },
            1200: {
                items: 2,
                dots: false,
                nav: false,
            }
        }
    });

    jQuery('#testimonial2Slider').owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        navText: ["<span class='material-icons'>keyboard_arrow_left</span>", "<span class='material-icons'>keyboard_arrow_right</span>"],
        dots: false,
        autoplay: true,
        lazyLoad: true,
    });


    //accordion js
    // Add minus icon for collapse element which is open by default
    // Add minus icon for collapse element which is open by default
    $(".collapse.show").each(function () {
        $(this).prev(".card-header").find(".fa").addClass("fa-minuss").removeClass("fa-pluss");
    });

    // Toggle plus minus icon on show hide of collapse element
    $(".collapse").on('show.bs.collapse', function () {
        $(this).prev(".card-header").find(".fa").removeClass("fa-pluss").addClass("fa-minuss");
    }).on('hide.bs.collapse', function () {
        $(this).prev(".card-header").find(".fa").removeClass("fa-minuss").addClass("fa-pluss");
    });

    /* back to top */
    var btn = jQuery('#backToTop');
    jQuery(window).scroll(function () {
        if (jQuery(window).scrollTop() > 300) {
            btn.addClass('show');
        } else {
            btn.removeClass('show');
        }
    });
    btn.on('click', function (e) {
        e.preventDefault();
        jQuery('html, body').animate({ scrollTop: 0 }, '300');
    });


    /* Quantity Plus Minus btn for Adult brushes in One time purchase */
    // This button will increment the value
    $('.addQtyAdult .qtyplus').click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name=' + fieldName + ']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(1);
        }
    });
    // This button will decrement the value till 0
    $(".addQtyAdult .qtyminus").click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name=' + fieldName + ']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(0);
        }
    });

    /* Quantity Plus Minus btn for Child brushes in One time purchase */
    $('.addQtyKid .qtyplus1').click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name=' + fieldName + ']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(1);
        }
    });
    // This button will decrement the value till 0
    $(".addQtyKid .qtyminus1").click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name=' + fieldName + ']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(0);
        }
    });


    /* Quantity Plus Minus btn for Adult brushes in Subscribe and save */
    // This button will increment the value
    $('.addQtyAdult .qtyplus2').click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name=' + fieldName + ']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(1);
        }
    });
    // This button will decrement the value till 0
    $(".addQtyAdult .qtyminus2").click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name=' + fieldName + ']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(0);
        }
    });

    /* Quantity Plus Minus btn for Child brushes in Subscribe and save */
    $('.addQtyKid .qtyplus3').click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name=' + fieldName + ']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(1);
        }
    });
    // This button will decrement the value till 0
    $(".addQtyKid .qtyminus3").click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name=' + fieldName + ']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(0);
        }
    });

    Shopify.moveAlongForSubs = function () {
        if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlongForSubs);
        } else {
            window.setTimeout(function(){
              try {
                  var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
              } catch (err) {
                  var paramLinker = '';
              }
              var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
              var paramCustomer = '{% if customer %}&customer_id={{ customer.id }}&customer_email={{ customer.email }}{% endif %}';
              window.rc_link = "https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer;
              window.location = window.rc_link;
            },100);
            
        }
    };

    Shopify.moveAlong = function () {
        if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
        } else {
            window.setTimeout(function(){
                window.location = '/checkout';
            },100);
        }
    };

    Shopify.addItem = function (id, qty, properties, callback) {
        if (typeof id == 'undefined' || id == "") {
            callback();
            return true;
        }
        var params = {
            quantity: qty,
            id: id
        };
        if (properties != false) {
            params.properties = properties;
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: params,
            success: function () {
                if (typeof callback === 'function') {
                    callback();
                }
            },
            error: function () { }
        });
    }
    function push_to_queue(variantID, quantity, properties, callback) {
        Shopify.queue.push({
            variantId: variantID,
            quantity: quantity,
            properties: properties
        });
        if (typeof callback === 'function') {
            callback();
        }
    }

    //push_to_queue(chocolate_vid, chocolate_qty, line_properties, null);

    /* OTP Purchase */
    $(document).on("click",".oneTimePurchaseWrapper button.dontMissBtn ",function(e){
        var adult_qty = $(".oneTimePurchaseWrapper .addQtyAdult [name='quantity']").val();
        var children_qty = $(".oneTimePurchaseWrapper .addQtyKid [name='quantity1']").val();
        if(adult_qty == 0 && children_qty == 0) {
            return false;
        }

        if(adult_qty > 0) {
            push_to_queue(adult_otp_product, adult_qty, {}, null);
            /*
            fbq('track', 'AddToCart', {
                content_name: "Curvy Bamboo - Year's Supply (Adult) - [One Time Purchase]", 
                content_ids: [adult_otp_product],
                content_type: 'product',
                value: 20 * parseInt(adult_qty),
                currency: 'GBP',
                quantity:  adult_qty
            });
            */
        }

        if(children_qty > 0) {
            push_to_queue(child_otp_product, children_qty, {}, null);
            /*
            fbq('track', 'AddToCart', {
                content_name: "Curvy Bamboo - Year's Supply (Childrens) - [One Time Purchase]", 
                content_ids: [child_otp_product],
                content_type: 'product',
                value: 20 * parseInt(children_qty),
                currency: 'GBP',
                quantity:  children_qty
            });
            */
        }
        Shopify.moveAlong();
    });

    /* Subscription Purchase */
    $(document).on("click",".subscribeSaveWrapper button.dontMissBtn ",function(e){
        var adult_qty = $(".subscribeSaveWrapper .addQtyAdult [name='quantity2']").val();
        var children_qty = $(".subscribeSaveWrapper .addQtyKid [name='quantity3']").val();      
        if(adult_qty == 0 && children_qty == 0) {
            return false;
        }

        if(adult_qty > 0) {
            var line_properties = {};
            line_properties.subscription_id = 240276;
            line_properties.shipping_interval_unit_type = "Months";
            line_properties.shipping_interval_frequency = 12;
            push_to_queue(adult_sub_product, adult_qty, line_properties, null);
            /*
            fbq('track', 'AddToCart', {
                content_name: "Curvy Bamboo - Year's Supply (Adult) - [Subscribe & Save] - Yr 1", 
                content_ids: [adult_sub_product],
                content_type: 'product',
                value: 20 * parseInt(adult_qty),
                currency: 'GBP',
                quantity:  adult_qty
            });
            */
        }
        if(children_qty > 0) {
            var line_properties = {};
            line_properties.subscription_id = 240276;
            line_properties.shipping_interval_unit_type = "Months";
            line_properties.shipping_interval_frequency = 12;

            /*
            fbq('track', 'AddToCart', {
                content_name: "Curvy Bamboo - Year's Supply (Childrens) - [Subscribe & Save] - Yr 1", 
                content_ids: [child_otp_product],
                content_type: 'product',
                value: 20 * parseInt(children_qty),
                currency: 'GBP',
                quantity:  children_qty
            });
            */

            push_to_queue(child_sub_product, children_qty, line_properties, null);
        }
        Shopify.moveAlongForSubs();
    });

});